import React, { useEffect, useRef } from 'react';

const ADSENSE_CLIENT = 'ca-pub-9128131594785947';

/**
 * AdSense ad slot. Hidden for authenticated admins.
 * Variants define layout/format hints for AdSense responsive ads.
 */
export function AdSlot({ slotId, variant = 'responsive', className = '', testId }) {
  const insRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (pushedRef.current) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (e) {
      // AdSense not loaded yet or ad blocker
      // eslint-disable-next-line no-console
      console.debug('AdSense push skipped:', e?.message);
    }
  }, []);

  const baseStyle = { display: 'block' };
  const formatByVariant = {
    responsive: { format: 'auto', fullWidth: 'true' },
    inarticle: { layout: 'in-article', format: 'fluid' },
    rectangle: { format: 'rectangle' },
  };
  const cfg = formatByVariant[variant] || formatByVariant.responsive;

  return (
    <div
      className={`w-full my-6 flex flex-col items-center ${className}`}
      data-testid={testId || `ad-slot-${variant}`}
    >
      <p className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Publicidad</p>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={variant === 'rectangle' ? { ...baseStyle, width: 336, height: 280 } : baseStyle}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slotId}
        data-ad-format={cfg.format}
        {...(cfg.layout ? { 'data-ad-layout': cfg.layout } : {})}
        {...(cfg.fullWidth ? { 'data-full-width-responsive': cfg.fullWidth } : {})}
      />
    </div>
  );
}
